import React, { ReactElement, FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Card, Divider, Typography } from 'antd'
// import { ContactDetails } from '../../../../Components/UI'
import { Attachments } from './Attachments'
import { s } from './style'
import { getAddress } from '../../../../Graphql-Utilities'
import { formatCents, openGoogleMaps } from '../../../../Utilities'
import { useDateTimeDuration } from '../../../../Hooks'
import { ConfirmedIcon } from './ConfirmedIcon'
import { ProposalModal } from '../../ProposalModal'
import {
  ConfirmedBookingEventFragment,
  ConfirmedBookingProposalFragment,
} from './ConfirmedBooking.generated-types'

const { Link, Text, Title } = Typography

interface ConfirmedBookingProps {
  event: ConfirmedBookingEventFragment
  proposal: ConfirmedBookingProposalFragment
}

export const ConfirmedBooking: FC<ConfirmedBookingProps> = ({
  event,
  // event: { name, currency, accountManager },
  event: { name, currency },
  proposal,
  proposal: {
    baseCostTotal,
    space: { spacePhotos, spaceName, venue },
  },
}): ReactElement => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { durationFullDate, durationRange } = useDateTimeDuration(event)

  const address = getAddress(proposal)

  const handleViewDetails = (): void => {
    setIsModalVisible(true)
  }

  const handleCloseModal = (): void => setIsModalVisible(false)

  return (
    <>
      <div style={s.root}>
        <div>
          <div style={s.firstRow}>
            <Title level={3} style={s.title}>
              {name}
            </Title>
            <Title level={4} style={s.title}>
              {t('eventHub.confirmed.totalSpend', 'Total spend (ex VAT)')}
            </Title>
          </div>
          <div style={s.secondRow}>
            <Text style={s.dateTime}>{`${durationFullDate}${
              durationRange ? ', ' + durationRange : ''
            }`}</Text>
            <Text strong>{formatCents(currency, baseCostTotal)}</Text>
          </div>
        </div>
        <Card style={s.card} bodyStyle={s.cardBody}>
          {spacePhotos && spacePhotos.length > 2 ? (
            <div style={s.images.root}>
              <img
                style={s.images.primary}
                src={spacePhotos[0].url}
                alt='Main space photo'
                height='334'
              />
              <div style={s.images.side}>
                <img
                  style={s.images.sideImages}
                  src={spacePhotos[1].url}
                  alt='Second space photo'
                  height='167'
                />
                <img
                  style={s.images.sideImages}
                  src={spacePhotos[2].url}
                  alt='Third space photo'
                  height='167'
                />
              </div>
            </div>
          ) : spacePhotos && spacePhotos.length > 0 ? (
            <img style={s.image} src={spacePhotos[0].url} alt='Main space photo' height='334' />
          ) : undefined}
          <div style={s.confirmedGrid}>
            <ConfirmedIcon style={s.tick} />
            <div style={s.confirmedAt}>
              <Text>{t('eventHub.confirmed.bookingConfirmedAt', 'Your booking is confirmed')}</Text>
              {venue && (
                <Text style={s.venueSpace}>{`at ${venue.name}${
                  spaceName ? ', ' + spaceName : ''
                }`}</Text>
              )}
            </div>
            <Text strong style={s.cost}>
              {formatCents(currency, baseCostTotal)}
            </Text>
            {address && (
              <div style={s.address}>
                <Text>{address}</Text>
                <Link onClick={() => openGoogleMaps(address)}>
                  {t('eventHub.confirmed.showOnMap', 'Show on a map')}
                </Link>
              </div>
            )}
            <Button onClick={handleViewDetails} type='link' style={s.details}>
              {t('eventHub.confirmed.viewDetails', 'View details')}
            </Button>
          </div>
          <Divider style={s.divider} />
          {/* <ContactDetails
            style={s.contactDetails}
            firstName={accountManager?.firstName}
            email={accountManager?.email}
            phone={accountManager?.phoneNumber}
          /> */}
          <Divider style={s.divider} />
          <Attachments proposal={proposal} strong style={s.attachment} />
        </Card>
      </div>
      <ProposalModal
        modalVisible={isModalVisible}
        handleCloseModal={handleCloseModal}
        response={proposal}
        canRequestToBook={false}
        event={event}
      />
    </>
  )
}
